import {DDay} from "../DDay";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Layers} from "./DDayLayers";
import {TimelineLite, Expo} from "gsap";
import {DDayGameConfig} from "../DDayGameConfig";
import {BlitzKriegSound} from "../sound/BlitzKriegSound";
import {BlitzKriegReelController} from "../reels/BlitzKriegReelController";

export class DDayScatterAnticipationView extends PIXI.Container {
    private _anticipations: PIXI.spine.Spine[];

    constructor() {
        super();
        this.init();
    }

    private init() {
        this._anticipations = [];
        let container: PIXI.Container = new PIXI.Container();
        container.position.set(360, 360);
        for (let i: number = 0; i < 3; i++) {
            let _anticipation = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("Anticipation"));
            _anticipation.alpha = 0;
            _anticipation.position.x = i * DDayGameConfig.SYMBOL_WIDTH;
            this._anticipations.push(_anticipation);
            container.addChild(_anticipation);
        }
        NolimitApplication.getLayerByName(Layers.FOREGROUND)?.addChild(container);
    }

    public playScatterAnimation(reelId: number): TimelineLite {
        let reelIndex: number = reelId - 2;
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            if (this.isFirstNearWinReelId(reelId)) {
                BlitzKriegSound.fadeMusic(0.7, 0.2);
                BlitzKriegSound.playTrack({name: "scatterAnticipationStart"});
                BlitzKriegSound.playTrackWithLoop({name: "scatterAnticipationLoop"});
            }
            this._anticipations[reelIndex].state.setAnimation(0, "reel_" + (3 - reelIndex), true);
        });
        tl.to(this._anticipations[reelIndex], {
            alpha: 1,
            duration: 0.3,
            ease: Expo.easeOut
        });
        return tl;
    }

    public isFirstNearWinReelId(reelId: number): boolean {
        let isFirst: boolean = true;
        for (let reelIdx: number = 0; reelIdx < reelId; reelIdx++) {
            if (DDay.model.parsedGameData.nearWinReels[reelIdx]) {
                isFirst = false;
                break;
            }
        }
        return isFirst;
    }

    public stopScatterAnimation(reelId: number): TimelineLite {
        let reelIndex: number = reelId - 2;
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            if (reelId === 4) {
                BlitzKriegSound.fadeMusic(1, 0.5);
                BlitzKriegSound.fadeAndStopSound({name: "scatterAnticipationLoop", to: 0, from: 1, duration: 0.02});
                BlitzKriegSound.playTrack({name: "scatterAnticipationEnd"});
            }
            this._anticipations[reelIndex].state.addAnimation(0, "reel_" + (3 - reelIndex), false, 0)
        });
        tl.to(this._anticipations[reelIndex], {
            alpha: 0,
            duration: 0.2,
            ease: Expo.easeIn
        });
        return tl;
    }
}
